"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableJs = void 0;
const enableJs = () => {
    document.documentElement.classList.remove('no-js');
};
exports.enableJs = enableJs;
